export default "__VITE_ASSET__0e64bfcd__"